module.exports = __webpack_public_path__ + "img/chicken_half.4962473d.svg";